(function () {

    "use strict";

    function selectController() {
        var vm = this;

        vm.selectedItem;
        vm.getSelectedText = function () {
            if (vm.selectedItem !== undefined) {
                return "Item selecionado:  " + vm.selectedItem.name;
            } else {
                return "Porfavor selecciona Item";
            }
        };
    }

    selectController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsSelect", {
            controller: selectController,
            bindings: {
                nameLabel: "=",
                items: "=",
                nameItem: "=",
                modelItem: "=",
                model: "=",
                selectedItem: "=",
                required: "="
            },
            templateUrl: "modules/main/components/ui/select/select.template.html"
        });

}());
